import { useMutation } from '@tanstack/react-query';
import { useRepositoryRegistry } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { WithEnterpriseId } from '@mews-commander/types';
import { deleteBills } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { WithBillIds } from '../types';

type MutationParameters = WithBillIds & WithEnterpriseId;

export const useDeleteBills = () => {
    const dispatch = useCommanderThunkDispatch();
    const { bills } = useRepositoryRegistry();
    return useMutation({
        mutationFn: async ({ billIds, enterpriseId }: MutationParameters) =>
            bills.delete({
                enterpriseId,
                billIds,
            }),
        onSuccess: (_, { billIds }) => {
            showSuccessAlert({
                title: lt('DeleteBillSuccessMessage'),
            });
            dispatch(deleteBills(billIds));
        },
    });
};
